module.exports = __webpack_public_path__ + "img/flandre.68e08065.png";